<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <div class="max-w-md w-full text-center fade-in">
      <div class="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
        <span class="text-4xl font-bold text-gray-400">404</span>
      </div>
      <h1 class="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h1>
      <p class="text-gray-600 mb-6">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <router-link
        to="/dashboard"
        class="btn btn-primary"
      >
        <font-awesome-icon icon="arrow-left" class="mr-2" />
        Back to Dashboard
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>





